"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var lodash_1 = __importDefault(require("lodash"));
var shortlink_1 = __importDefault(require("../util/shortlink"));
var index_1 = require("../../index");
var ConfigOption_1 = __importStar(require("../../../../widgets/ConfigOption"));
var TagsAutocomplete_1 = __importDefault(require("../../../../widgets/TagsAutocomplete"));
var Tooltip_1 = __importDefault(require("../../../../widgets/Tooltip"));
var constants_1 = require("../../../../../../shared/constants");
var TrailingButton_1 = __importDefault(require("./TrailingButton"));
var validation_1 = require("../../../../../../shared/util/validation");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        tagsAutoCompleteWrapper: {
            marginTop: theme.spacing(1),
        },
    });
});
function TagsEditor() {
    var theme = core_1.useTheme();
    var classes = useStyles();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var drawerStates = index_1.useDrawerState();
    var _a = shortlink_1.default(drawerStates.relevantShortLink), shortLinkState = _a.shortLinkState, shortLinkDispatch = _a.shortLinkDispatch;
    var initialTags = (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.tags) || [];
    var _b = __read(react_1.useState(initialTags), 2), tags = _b[0], setTags = _b[1];
    var _c = __read(react_1.useState(''), 2), tagInput = _c[0], setTagInput = _c[1];
    return (react_1.default.createElement(ConfigOption_1.default, { title: react_1.default.createElement(react_1.default.Fragment, null,
            "Tag (add up to ",
            react_1.default.createElement("strong", null,
                constants_1.MAX_NUM_TAGS_PER_LINK,
                " tags"),
            ")",
            ' ',
            react_1.default.createElement(Tooltip_1.default, { title: "Tags are words, or combinations of words, you can use to classify or describe your link.", imageAltText: "Tags help" })), leading: react_1.default.createElement("div", { className: classes.tagsAutoCompleteWrapper },
            react_1.default.createElement(TagsAutocomplete_1.default, { tags: tags, setTags: setTags, tagInput: tagInput, setTagInput: setTagInput, disabled: tags.length >= constants_1.MAX_NUM_TAGS_PER_LINK, fixHelperTextPosition: true })), trailing: react_1.default.createElement(TrailingButton_1.default, { disabled: !validation_1.isValidTags(tags) ||
                lodash_1.default.isEqual(__spreadArray([], __read(tags)).sort(), __spreadArray([], __read(initialTags)).sort()) ||
                !validation_1.isValidTag(tagInput, true), onClick: function () {
                // Ensure tags are updated with any remaining tag input before saving
                var tagsForSaving = tagInput && validation_1.isValidTag(tagInput) && !tags.includes(tagInput)
                    ? __spreadArray(__spreadArray([], __read(tags)), [tagInput]) : tags;
                shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.applyEditTags(tagsForSaving);
            }, fullWidth: isMobileView, variant: isMobileView ? 'contained' : 'outlined' }, "Save"), wrapTrailing: isMobileView, trailingPosition: ConfigOption_1.TrailingPosition.end }));
}
exports.default = TagsEditor;
